// EditCategory.jsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FaSave } from 'react-icons/fa';
import Header from '../../../../../header/header';
import Navvbar from '../../../../../header/Navvbar';
import Sidebar from '../../../../../Sidebar';
import Footer from '../../../../../footer';

const EditCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    sortrank: '',
    customId: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // 1. Fetch existing category data on mount
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const res = await fetch(`https://hms.backend.hiragroupcloud.com/api/categories?userLabId=${localStorage.getItem('userLabId')}`);
        if (!res.ok) throw new Error('Failed to fetch categories');
        const data = await res.json();
        const category = data.find(cat => cat._id === id || cat.id === id);
        if (category) {
          setFormData({
            name: category.name || '',
            sortrank: category.sortrank || '',
            customId: category.customId || ''
          });
        } else {
          setError('Category not found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCategory();
  }, [id]);

  // 2. Handle form changes
  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  // 3. Submit update
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`https://hms.backend.hiragroupcloud.com/api/categories/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.message || 'Update failed');
      }

      const updated = await res.json();
      Swal.fire({
        title: 'Updated!',
        text: 'Category updated successfully',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      });
      navigate('/display-categories');
    } catch (err) {
      Swal.fire({
        title: 'Error',
        text: err.message,
        icon: 'error',
        confirmButtonColor: '#004aad'
      });
    }
  };

  if (loading) return <div style={{ padding: '40px' }}>Loading...</div>;
  if (error) return <div className="text-danger" style={{ padding: '40px' }}>{error}</div>;

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        overflow: 'hidden'
      }}
    >
      {/* Top Header */}
      <Header />

      {/* Navbar */}
      <Navvbar />

      {/* Main Layout Wrapper */}
      <div
        style={{
          display: 'flex',
          flex: 1,
          padding: '25px 40px 30px 40px',
          gap: '0px',
          boxSizing: 'border-box',
          maxWidth: '100%',
          overflowY: 'auto'
        }}
      >
        {/* ================= Left Sidebar (LEFT shifted) ================= */}
        <div
          style={{
            width: '200px',
            flexShrink: 0,
            marginLeft: '20px',              // 👈 40px → 20px (sidebar left gaya)
            borderRight: '1px solid #ddd',
            paddingRight: '20px',
            minHeight: '500px'
          }}
        >
          <Sidebar />
        </div>

        {/* ================= Right Content Area (SAME position) ================= */}
        <div
          style={{
            flex: 1,
            paddingTop: '5px',
            paddingLeft: '50px',             // 👈 30px → 50px (content same jagah)
            maxWidth: '1200px'
          }}
        >
          {/* Page Title */}
          <h2
            style={{
              fontSize: '28px',
              fontWeight: '400',
              color: '#004aad',
              marginBottom: '20px',
              marginTop: '0'
            }}
          >
            Edit Display Category
          </h2>

          {/* "Details" heading with FULL-WIDTH blue underline */}
          <h4
            style={{
              color: '#004aad',
              fontSize: '18px',
              fontWeight: '400',
              borderBottom: '1px solid #004aad',
              paddingBottom: '8px',
              marginBottom: '0',
              marginTop: '0'
            }}
          >
            Details
          </h4>

          {/* Grey Section with form fields */}
          <div
            style={{
              backgroundColor: '#ececec',
              padding: '25px 30px',
              width: '100%',
              boxSizing: 'border-box'
            }}
          >
            <form onSubmit={handleSubmit}>
              {/* Name Field */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '22px'
                }}
              >
                <label
                  style={{
                    width: '130px',
                    fontWeight: '700',
                    fontSize: '15px',
                    color: '#222',
                    marginBottom: '0'
                  }}
                >
                  Name <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    maxWidth: '220px',
                    fontSize: '14px',
                    padding: '6px 12px',
                    border: '1px solid #ccc',
                    borderRadius: '3px'
                  }}
                />
              </div>

              {/* Sort Rank Field */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '22px'
                }}
              >
                <label
                  style={{
                    width: '130px',
                    fontWeight: '700',
                    fontSize: '15px',
                    color: '#222',
                    marginBottom: '0'
                  }}
                >
                  Sort Rank <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  name="sortrank"
                  value={formData.sortrank}
                  onChange={handleChange}
                  style={{
                    maxWidth: '80px',
                    fontSize: '14px',
                    padding: '6px 12px',
                    border: '1px solid #ccc',
                    borderRadius: '3px'
                  }}
                />
              </div>

              {/* Custom ID Field */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '10px'
                }}
              >
                <label
                  style={{
                    width: '130px',
                    fontWeight: '700',
                    fontSize: '15px',
                    color: '#222',
                    marginBottom: '0'
                  }}
                >
                  Custom ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="customId"
                  value={formData.customId}
                  onChange={handleChange}
                  placeholder="Custom Identifier"
                  style={{
                    maxWidth: '220px',
                    fontSize: '14px',
                    padding: '6px 12px',
                    border: '1px solid #ccc',
                    borderRadius: '3px'
                  }}
                />
              </div>
            </form>
          </div>

          {/* Save Button */}
          <div style={{ marginTop: '15px' }}>
            <button
              type="submit"
              onClick={handleSubmit}
              className="btn"
              style={{
                backgroundColor: '#004aad',
                color: '#fff',
                padding: '8px 18px',
                fontWeight: '500',
                fontSize: '14px',
                border: 'none',
                borderRadius: '3px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                cursor: 'pointer'
              }}
            >
              <FaSave size={14} /> Save
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default EditCategory;